import React from 'react';
import { jsPDF } from "jspdf";

import {
    Button
} from 'reactstrap';

import Isvg from 'react-inlinesvg';
import printModal from '../assets/svg/print-modal.svg'
import Save from '../assets/svg/save.svg';
import { API_ENDPOINT } from '../constants';

/**
* Open print page of browser, generate Save PDF button
* @author   Milan Stanojevic
*/
function extractFirstImgSrc(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const firstImg = doc.querySelector("img");
    return firstImg ? firstImg.src : null;
}
function isImageTransparent(imgSrc) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = imgSrc;

        img.onload = () => {
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;
            context.drawImage(img, 0, 0);
            const imageData = context.getImageData(0, 0, img.width, img.height).data;
            for (let i = 3; i < imageData.length; i += 4) {
                if (imageData[i] < 255) {
                    resolve(true);
                    return;
                }
            }
            resolve(false);
        };

        img.onerror = () => {
            resolve(false);
            // reject(new Error("Image cannot be loaded"));
        };
    });
};
function addWhiteBackgroundToImage(html, targetImgUrl) {
    return new Promise((resolve, reject) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const images = Array.from(doc.querySelectorAll("img"));

        let found = false;

        images.forEach((img) => {
            if (img.src === targetImgUrl) {
                found = true;
                const imageElement = new Image();
                imageElement.crossOrigin = "Anonymous";
                imageElement.src = targetImgUrl;

                imageElement.onload = () => {
                    const canvas = document.createElement("canvas");
                    const context = canvas.getContext("2d");

                    canvas.width = imageElement.width;
                    canvas.height = imageElement.height;

                    context.fillStyle = "white";
                    context.fillRect(0, 0, canvas.width, canvas.height);

                    context.drawImage(imageElement, 0, 0);

                    img.src = canvas.toDataURL();
                    resolve(doc.body.innerHTML);
                };

                imageElement.onerror = () => {
                    resolve(null)
                    // reject(new Error(`Image cannot be loaded: ${targetImgUrl}`));
                };
            }
        });

        if (!found) {
            resolve(html);
        }
    });
}

class PrintHelper extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    checkHtml = async (html) => {
        // console.log('html', html)
        let imgSrc = extractFirstImgSrc(html);
        if (API_ENDPOINT?.includes('localhost') && imgSrc?.includes('localhost') && imgSrc?.includes('https')) {
            html = html.replace(imgSrc, imgSrc.replace('https', 'http'));
            imgSrc = imgSrc.replace('https', 'http');
        }
        let isTransparent = false;
        if (imgSrc) {
            isTransparent = await isImageTransparent(imgSrc);
        }
        if (isTransparent) {
            let newHtml = await addWhiteBackgroundToImage(html, imgSrc);
            if (newHtml) {
                html = newHtml;
            }
        }
        return html;
    }
    initialGet = async () => {
        const doc = new jsPDF('p', 'mm', [210, 297]);
        const html = await this.checkHtml(this.props.html)
        doc.html(`<div style="width:1100px;padding: 100px 50px;">${html}</div>`, {
            margin: [20, 20, 20, 20],

            html2canvas: {
                scale: 0.1909,
            },

            callback: () => {
                this.setState({
                    blob: doc.output('bloburl'),
                    docObj: doc
                })
            },

        })
    }
    componentDidMount() {
        this.initialGet()

    }

    render() {
        return (
            <div>


                {this.state.blob && this.state._loaded ?
                    <Button style={{ marginRight: 10 }} onClick={() => {
                        this.iframe.focus();
                        this.iframe.contentWindow.print()
                    }}><Isvg src={printModal} style={{ marginRight: 5 }} />
                        {'Print'.translate(this.props.lang)}
                    </Button>

                    :
                    null
                }
                {this.state.docObj ?
                    <Button style={{ marginRight: 0, backgroundColor: '#3A3F56' }} onClick={() => {
                        this.state.docObj.save('invoice.pdf');
                    }}><Isvg src={Save} style={{ marginRight: 5 }} />
                        {'Save as pdf'.translate(this.props.lang)}
                    </Button>
                    :
                    null
                }

                <iframe width="0" height="0" style={{ border: 0 }} src={this.state.blob} ref={(node) => this.iframe = node} onLoad={() => this.setState({ _loaded: true })}></iframe>

            </div>
        )
    }
}

export default PrintHelper;